import React from 'react';
import { ChatCircle, Trash } from '@phosphor-icons/react';

const SessionItem = ({ session, isActive, isFirst, onClick, onDelete }) => {
  const handleDeleteClick = (e) => {
    e.stopPropagation(); // Prevent triggering session selection
    onDelete();
  };

  return (
    <div
      className={`group session-item flex items-center p-3 rounded-lg mb-1 cursor-pointer text-gray-700 hover:bg-gray-100 transition-all ${
        isActive ? 'active bg-gray-100 border-l-2 border-l-indigo-500' : ''
      } ${isFirst ? 'mt-0' : ''}`}
      onClick={onClick}
    >
      <ChatCircle size={14} className="text-gray-400 mr-2 flex-shrink-0" />
      <div className="session-content flex-1 min-w-0">
        <div className="session-title text-sm font-medium truncate">
          {session.title || (isFirst ? "New Chat" : `Chat ${session.id}`)}
        </div>
      </div>

      <button
        className="session-delete-btn hidden group-hover:block text-gray-400 hover:text-red-500 transition-colors"
        onClick={handleDeleteClick}
      >
        <Trash size={14} />
      </button>
    </div>
  );
};

export default SessionItem;
